import { Stack } from '@mui/material';
import FormNav from 'common/components/FormNav';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import ShortVideoFormAssets from './ShortVideoFormAssets';
import ShortVideoFormConfirm from './ShortVideoFormConfirm';
import ShortVideoFormSettings from './ShortVideoFormSettings';

const ShortVideoFormData = ({
    fields,
    handleFieldChange,
    step,
    setStep,
    cancel,
    openSubForm,
    closeSubForm,
    handleSubmit,
    assets,
    pending,
}) => {
    const { t } = useTranslation();
    const { classes: flexBox } = useFlexBoxStyles();

    const visibleSteps = [
        t('event.eventFormNav.settings'),
        t('event.eventFormNav.assets'),
        t('event.eventFormNav.confirm'),
    ];

    return (
        <Stack direction="column" spacing={3} className={flexBox.overflowHidden}>
            <FormNav step={step} setStep={setStep} steps={visibleSteps} wizardMode={!pending} />
            <Stack direction="column" className={flexBox.overflowHidden}>
                {
                    {
                        1: (
                            <ShortVideoFormSettings
                                data={fields}
                                handleFieldChange={handleFieldChange}
                                step={step}
                                setStep={setStep}
                                cancel={cancel}
                                open={openSubForm}
                                close={closeSubForm}
                            />
                        ),
                        2: (
                            <ShortVideoFormAssets
                                assets={assets}
                                step={step}
                                setStep={setStep}
                                open={openSubForm}
                                close={closeSubForm}
                                cancel={cancel}
                            />
                        ),
                        3: (
                            <ShortVideoFormConfirm
                                data={fields}
                                step={step}
                                pending={pending}
                                setStep={setStep}
                                cancel={cancel}
                                onSubmit={handleSubmit}
                            />
                        ),
                    }[step]
                }
            </Stack>
        </Stack>
    );
};

export default ShortVideoFormData;
